// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "grafana." + ({"48926":"react-monaco-editor","50190":"geomapPanel","88658":"react-monaco-diff-editor"}[chunkId] || chunkId) + "." + {"856":"a45e45977094df4a0bc9","36503":"ffb3a9cd952d3cd7471b","48926":"ffb3a9cd952d3cd7471b","50190":"aacf80d11011e67cf843","88658":"ffb3a9cd952d3cd7471b"}[chunkId] + ".css";
};